import React from 'react'
import {ContractMethod, CvsContractInfo, DisplayCreditCardExpireDate, MobileCarrierKey} from '../../../../Props/ContractInputInfo'
import {PAYMENT} from '../../../../../Common/Constants'
import {Optional} from '../../../../../Common/TypeHelper'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyTypography, MBContentSubTitleTypography} from '../../../Atoms/Typographies'
import {convenienceStoreKeyToName} from '../InputContentBlocks/ConvenienceStoreInputComponent'
import {ConfirmContent} from '../../../Molecules/BaseContentBlocks/ConfirmContent'
import {LinkIconText} from '../../../Molecules/LinkIconText'
import {ColumnFlexContainer} from '../../../Atoms/Containers'

type ConfirmContractDetailContentProps = {
  label: string
  method: Optional<ContractMethod>
  cardNumber?: string
  cardExpireDate?: string
  carrierKey?: MobileCarrierKey
  cvsInfo?: CvsContractInfo
  testDataId?: string
}

export const ConfirmContractDetailContent: React.VFC<ConfirmContractDetailContentProps> =
  (props: ConfirmContractDetailContentProps) => {
    const {cvsInfo} = props
    const showCvsPaymentInfo = isShowCvsPaymentInfo(cvsInfo)

    return (
      <PIMStack spacing={'10px'} testId={props.testDataId}>
        <MBContentSubTitleTypography>{props.label}</MBContentSubTitleTypography>
        {props.method && (
          <div>
            <MBContentBodyTypography>
              {PAYMENT.METHODS_FOR_RADIO_LABEL[props.method]}
            </MBContentBodyTypography>
            {(props.cardNumber !== undefined && props.cardExpireDate !== undefined) && (
              <PIMStack direction={'row'} alignItems={'baseline'}>
                <MBContentBodyTypography>{props.cardNumber}</MBContentBodyTypography>
                <DisplayCreditCardExpireDate expireDate={props.cardExpireDate}/>
              </PIMStack>
            )}
            {props.carrierKey && (
              <MBContentBodyTypography>{`決済キャリア：${props.carrierKey}`}</MBContentBodyTypography>
            )}
            {cvsInfo &&
            <div>
              {cvsInfo.convenienceStoreKey !== '' &&
              <MBContentBodyTypography>
                {`お支払い先コンビニ：${convenienceStoreKeyToName(cvsInfo.convenienceStoreKey)}`}
              </MBContentBodyTypography>
              }
              {showCvsPaymentInfo && <>
                <MBContentBodyTypography>
                  {`${cvsInfo.paymentNumberLabel}：${cvsInfo.paymentNumber}`}
                </MBContentBodyTypography>
                <MBContentBodyTypography>
                  {`${cvsInfo.confirmationNumberLabel}：${cvsInfo.confirmationNumber}`}
                </MBContentBodyTypography>
                <MBContentBodyTypography>
                  {`お支払い期限：${cvsInfo.paymentTerm}`}
                </MBContentBodyTypography>
                {cvsInfo.paymentDetailUrl !== null &&
                <ColumnFlexContainer alignItems={'center'} gap={'10px'}>
                  <ConfirmContent
                    label={''}
                    values={['下記リンクよりお支払い方法をご確認ください。']}
                  />
                  <LinkIconText
                    href={cvsInfo.paymentDetailUrl}
                    dataTestId={'confirm-content-cvs-payment-detail'}
                  >
                    {`${convenienceStoreKeyToName(cvsInfo.convenienceStoreKey)}でのお支払い方法について`}
                  </LinkIconText>
                </ColumnFlexContainer>
                }
              </>}
            </div>
            }
          </div>
        )}
      </PIMStack>
    )
  }

const isShowCvsPaymentInfo = (cvsInfo?: CvsContractInfo): boolean =>
  cvsInfo !== undefined
  && cvsInfo.paymentNumber !== null
  && cvsInfo.paymentNumberLabel !== null
  && cvsInfo.confirmationNumber !== null
  && cvsInfo.confirmationNumberLabel !== null
  && cvsInfo.paymentTerm !== null
  && cvsInfo.paymentDetailUrl !== null
